import VideoDataStore from 'models/video_data_store'

export class CustomControlBase {
  constructor(video, options = {}) {
    this.video = video
    this.unbinds = []
    this.buttonText = options.buttonText
    this.buttonLabel = options.buttonLabel
  }

  getDataStore(){
    return VideoDataStore.getStore(this.video.hashedId())
  }

  mountButton(buttonRoot) {
    this.buttonRoot = buttonRoot
    this.updateButtonText()
    this.setButtonLabel(this.buttonLabel)
  }

  destroy() {
    this.unbinds.map(unbind => unbind())
    this.unbinds = []
  }

  onControlPropsUpdated(prevProps) {
    if (prevProps.scale !== this.props.scale) {
      this.buttonRoot.style.transform = `scale(${this.props.scale})`
    }
  }
}

CustomControlBase.shouldMount = (video) => {
  return video._opts.customSeekControls === true
}

CustomControlBase.type = 'control-bar-left'
CustomControlBase.isVideoChrome = true
CustomControlBase.width = 30
